"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var r = function r(_r) {
    if (!_r.includes("grid")) return _r;
    if ("display:grid" === _r) return "\n      display: -ms-grid;\n      display: grid;\n    ";
    if ("display:inline-grid" === _r) return "\n      display: -ms-inline-grid;\n      display: inline-grid;\n    ";
    var n = _r.match(/^grid-([a-z-]+): *(.+)/);
    if (!n) return _r;
    var i = n[1],
      e = n[2];
    return "template" === i ? function (r, n) {
      var i = n.split(/\s*\/\s*/),
        e = i[0],
        t = i[1],
        s = /repeat\((\d+), *(.+)\)/;
      return e && t ? "\n      -ms-grid-rows: " + e.replace(s, "($2)[$1]") + ";\n      -ms-grid-columns: " + t.replace(s, "($2)[$1]") + ";\n      grid-" + r + ": " + n + ";\n    " : r + ": " + n + ";";
    }(i, e) : "template-rows" === i || "template-columns" === i ? function (r, n) {
      return "\n    -ms-grid-" + r.split("-")[1] + ": " + n.replace(/repeat\((\d+), *(.+)\)/, "($2)[$1]") + ";\n    grid-" + r + ": " + n + ";\n  ";
    }(i, e) : "row" === i || "column" === i ? function (r, n) {
      var i = n.split(/\s*\/\s*/),
        e = i[0],
        t = i[1],
        s = null == t ? void 0 : t.match("span ");
      if (!e) return "\n      -ms-grid-" + r + ": " + n + ";\n      grid-" + r + ": " + n + ";\n    ";
      if (e && s) return "\n      -ms-grid-" + r + ": " + e + ";\n      -ms-grid-" + r + "-span: " + t.replace("span ", "") + ";\n      grid-" + r + ": " + n + ";\n    ";
      if (e && !s) {
        var d = parseInt(e);
        return "\n      -ms-grid-" + r + ": " + e + ";\n      -ms-grid-" + r + "-span: " + (parseInt(t) - d) + ";\n      grid-" + r + ": " + n + ";\n    ";
      }
      return "\n    grid-" + r + ": " + n + ";\n  ";
    }(i, e) : _r;
  },
  n = function n(_n, i) {
    if (1 === _n || 2 === _n) return Array.isArray(i) ? i.forEach(function (n) {
      return r(n);
    }) : r(i);
  };
Object.defineProperty(n, "name", {
  value: "griddie"
}), exports.default = n;